import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LoadingIndicator from 'components/LoadingIndicator';
import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import Popup from 'components/popup/popup';
import UploadDisplay from 'components/uploadFile/UploadDisplay';
import useCommentHistoryData from 'hooks/tableData/useCommentHistoryData';
import API from 'api/call';

const SLayout = styled.div``;

const GeneralCommentSheet = ({ formType, reportId }) => {
    const [isLoadingHistory, setLoadingHistory] = useState(false);
    const { rows, columns, isShow, setIsShow, setSelectedRow, selectedRow, setRows } = useCommentHistoryData(
        { formType },
    );

    const confirm = () => {
        setIsShow(false);
        setSelectedRow(null);
    };

    useEffect(() => {
        // get comment here
        setLoadingHistory(true);
        API.postApprovalActivities.getComment({ docType: formType, docId: reportId })
            .then(res => {
                setRows(res.data.result);
            })
            .finally(() => setLoadingHistory(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SLayout>
            <TextHeader underline> Comment History</TextHeader>

            <div style={{ marginTop: 20 }}>
                {isLoadingHistory ? (
                    <div style={{ height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadingIndicator /> <div style={{ marginLeft: 10 }}>Loading Comments...</div>
                    </div>
                ) : (
                    <CustomTable
                        skipMaxHeight
                        fullWidthTable={false}
                        showAlternativeBackground
                        rows={rows}
                        columns={columns}
                    />
                )}
            </div>
            <Popup
                height="60%"
                width="60%"
                title="View Attachments"
                open={isShow}
                footerActions={[{ label: 'Close', clicked: confirm }]}
                closePopup={confirm}
            >
                <UploadDisplay
                    fileList={(selectedRow?.files ?? []).map((item) => {
                        return { name: item.fileName, downloadId: item.id };
                    })}
                    enableDownload
                    apiUrl={API.postApprovalActivities.downloadStatusFile}
                />
            </Popup>
        </SLayout>
    );
};

export default GeneralCommentSheet;
